import { render, staticRenderFns } from "./docHeader.vue?vue&type=template&id=08ab7742&scoped=true&"
import script from "./docHeader.vue?vue&type=script&lang=js&"
export * from "./docHeader.vue?vue&type=script&lang=js&"
import style0 from "./docHeader.vue?vue&type=style&index=0&id=08ab7742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab7742",
  null
  
)

export default component.exports